import React, { useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import Avatar from '@material-ui/core/Avatar';
import Grid from '@material-ui/core/Grid';

import { urlConfig } from '../../../../config/urlConfig';
import { Box, Typography } from '@material-ui/core';
import { ProfileContext } from '../../../../services/profile/profile.context';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
  },
  list: {
    maxHeight: 150,
    overflowY: 'auto',
    marginBottom: '1rem',
  },
}));

export const UsersListComponent = ({
  value,
  addSearchTerm,
  searchList,
  isEmail,
  notFound,
  error,
}) => {
  const classes = useStyles();
  const { user } = useContext(ProfileContext);

  return (
    <div className={classes.root}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={8} md={6}>
          <Box boxShadow={2}>
            <List dense className={classes.list}>
              {isEmail && !notFound && !error && (
                <ListItem button onClick={() => addSearchTerm(value, false)}>
                  <ListItemText primary={`Invite "${value}" by email`} />
                </ListItem>
              )}

              {notFound && !error && (
                <ListItem>
                  <ListItemText primary={'not match found'} />
                </ListItem>
              )}

              {error && (
                <ListItem>
                  <ListItemText primary={`${error} has already been added`} />
                </ListItem>
              )}

              {searchList
                .filter((item) => {
                  let searchTerm = value && value.toLowerCase();

                  let username = item.username && item.username.toLowerCase();
                  let email = item.email && item.email.toLowerCase();

                  let usernameChecker =
                    username && username.includes(searchTerm);

                  let emailChecker = email && email.includes(searchTerm);

                  return searchTerm && (emailChecker || usernameChecker);
                })
                .slice(0, 8)
                .map(
                  (value) =>
                    value && (
                      <ListItem
                        button
                        disabled={
                          value.username === user.username ? true : false
                        }
                        key={value.username}
                        onMouseDown={() => addSearchTerm(value.username, false)}
                      >
                        <ListItemAvatar>
                          <Avatar
                            alt='avatar'
                            src={value.avatar}
                          />
                        </ListItemAvatar>
                        <ListItemText
                          secondary={
                            <>
                              <Typography
                                component='span'
                                variant='body2'
                                className={classes.inline}
                                color='textPrimary'
                              >
                                {value.email}
                              </Typography>
                              {/* ${value.username === user.username ? true : false ? `already have been added`}`
                              `${value.username === user.username ? null : already have been added }` */}
                            </>
                          }
                          primary={`${value.fname} ${value.lname}`}
                        />
                      </ListItem>
                    )
                )}
            </List>
          </Box>
        </Grid>
      </Grid>
    </div>
  );
};
